const styles = (theme) => ({
  title: {
    borderBottom: `1px solid ${theme.palette.underline.dark}`,
    paddingBottom: theme.spacing.unit * 2,
  },
});

export default styles;
